import React, { forwardRef } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link as URCLink, Button } from '@upgrade/react-components';

// Wrapper for Router Links to look like upgrade links or buttons
const Link = forwardRef(({ to, button, ariaLabel, ...props }, ref) => {
  return button ? (
    <Button
      {...{ ...props, ref }}
      buttonProps={{ 'aria-label': ariaLabel, ...(props.buttonProps || {}), as: GatsbyLink, to, type: null }}
    />
  ) : (
    <URCLink
      {...{ ...props, ref }}
      anchorComponent={props.anchorComponent || GatsbyLink}
      to={to}
      aria-label={ariaLabel}
    />
  );
});

export default Link;
